import { render } from "./authorizer.vue?vue&type=template&id=2e33fd64"
import script from "./authorizer.vue?vue&type=script&lang=js"
export * from "./authorizer.vue?vue&type=script&lang=js"

import "./authorizer.vue?vue&type=style&index=0&id=2e33fd64&lang=postcss"
script.render = render

export default script